<template>

    <Modal
        ref="modal"
    >
        <template #title>
            <div class="flex justify-center">
                <img src="/img/logo.svg" class="h-20" alt="">
            </div>
        </template>

        <h3 class="text-2xl font-semibold mt-4 mb-2">Change Password</h3>

        <TextInput class="mb-4" type="password" :errors="errors?.bag['current_password']" label="Old Password" v-model="fields.current_password" />
        <TextInput class="mb-4" type="password" :errors="errors?.bag['new_password']" label="New Password" v-model="fields.new_password" />
        <TextInput class="mb-4" type="password" :errors="errors?.bag['new_password_confirmation']" label="Confirm New Password" v-model="fields.new_password_confirmation" />

        <div class="flex justify-end">
            <Button @click="submit" type="primary" size="large">Change Password</Button>
        </div>
    </Modal>

</template>


<script setup lang="ts">

import Modal from "@/components/core/modals/Modal.vue";
import TextInput from "@/components/forms/inputs/TextInput.vue";
import {useApi} from "@/composables/useApi";
import Button from "@/components/core/Button.vue";
import {useApiError} from "@/composables/useApiError";

const modal = ref<InstanceType<typeof Modal>|null>(null);
const errors = ref<ReturnType<typeof useApiError>|null>(null);

const fields = ref({
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
});

async function submit() {
    const { error, fetch } = useApi({
        url: 'account/change-password',
        method: 'PATCH',
        payload: fields.value
    })

    await fetch();

    if(error.value) {
        errors.value = error.value;
        return;
    }

    close();
}

function open() {
    modal.value?.open();
}

function close() {
    modal.value?.close();
}

defineExpose({open, close});

</script>